import { ModalBodyTableFromTo } from '@ui/components/Modal/Body/Table/FromTo'
import { ModalBodyTableSort } from '@ui/components/Modal/Body/Table/Sort'

export const ModalBodyTable = { Sort: ModalBodyTableSort, FromTo: ModalBodyTableFromTo }
